import { all, fork } from 'redux-saga/effects'
import customFields from './custom-fields-saga'

export default function* flowResourcesSagas() {
  yield all([fork(customFields)])
}
